import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Typography, Button, TextField, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import { openLoginModal } from 'store/slice/HeaderSlice';
import { setMlmUserObj, setselectedPkgObj, setPartnershipInitiationMode } from 'store/slice/EcomSlice';
import FieldView1 from 'core/components/layout/FieldView1';
import { updateUserNameAPI } from 'api/CoreMlmmgmtWebServices';
import { setMlmuserEdituserModal } from 'store/slice/DmpSlice';
import EdituserActionModal from 'components/mlmuser/action/edituser/EdituserActionImpl';
import { setMlmuserOnboardModal } from 'store/slice/DmpSlice';
import { useNavigate } from 'react-router-dom';
import {setMlmuserInitPartnershipModal} from 'store/slice/DmpSlice';
import {setSelectedBottomMenu} from 'store/slice/EcomSlice';
import ProfileMgmtModal from 'core/components/profile-mgmt/ProfileMgmtModal';
import {setShowProfileMgmtModal} from 'store/slice/HeaderSlice';

export default function Confirmation() {
    const navigate= useNavigate();
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null);
    const { userprofileInfo } = useSelector((state) => state.headerslice);
    const { selectedPkgObj, mlmUserObj } = useSelector((state) => state.ecomslice.mlm);

    // Local state for editing
    const [editMode, setEditMode] = useState(false);
    const [partnerName, setPartnerName] = useState(userprofileInfo?.name || '');
    const [panNumber, setPanNumber] = useState(userprofileInfo?.pan || '');

    const handleUpdate = () => {

        if (partnerName.trim() === '') {
            alert("Partner name cannot be empty");
            return;
        }
        updateUserNameAPI(
            { userName: partnerName, pan: panNumber },
            updateUserNameAPISuccess,
            updateUserNameAPIFailure);

    }
    const updateUserNameAPISuccess = (apiResponse) => {
        setEditMode(false);
        dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
    }
    const updateUserNameAPIFailure = (apiResponse) => {

    }
    const handleUpdateDetails = () => {
        dispatch(setMlmuserEdituserModal(true));
        // setEditMode(true);
        // setPartnerName(mlmUserObj.title || '');
        // setPanNumber(mlmUserObj.pan || '');
    }

    // Add editProfile function
    const editProfile = () => {
       // dispatch(setMlmuserInitPartnershipModal(false));
        dispatch(setShowProfileMgmtModal(true));
    }

    const handleGoToMembership = () => {
        dispatch(setMlmuserInitPartnershipModal(false));
        dispatch(setPartnershipInitiationMode(false));
        dispatch(setMlmuserOnboardModal(false));
        dispatch(setSelectedBottomMenu('PARTNER'));

        
    }
const close = () =>{
        dispatch(setMlmuserInitPartnershipModal(false));
        dispatch(setPartnershipInitiationMode(false))
        dispatch(setMlmuserOnboardModal(false));
        dispatch(setSelectedBottomMenu('HOME'));
        
    }
    const getAddress = () => {
        let address = '';
        if (mlmUserObj) {
            if (mlmUserObj.address) address += mlmUserObj.address + ', ';
            if (mlmUserObj.city) address += mlmUserObj.city + ', ';
            if (mlmUserObj.pincode) address += mlmUserObj.pincode;
        }
        return address;
    }
    return (
        <>
            <Grid container xs={12} direction="row" justifyContent="flex-end" sx={{ width: '100%' }} >
                <Grid item xs={12}>
                    <Typography variant="h4" color="primary.darker">Onboarding Confirmation</Typography>
                </Grid>
            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 2,
                    mb: 2,
                    backgroundColor: 'white',
                    padding: 1,
                    borderRadius: 2,
                }}
            >
                <CheckCircleIcon color="success" sx={{ fontSize: 80, mr: 1 }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', pl: 2 }}>
                    <Typography variant="h4" color="success.main" sx={{ fontWeight: 700, mb: 1 }}>
                        Congratulations!
                    </Typography>
                    <Typography variant="h5" color="primary.darker" sx={{}}>
                        You are now our Business Associate.
                    </Typography>
                    <Typography variant="h6" color="primary.darker" sx={{ fontSize:15, mt:1}}>
                        Your Referal code is # {mlmUserObj.id}
                    </Typography>
                </Box>
            </Box>

            {/* Scrollable content starts here */}
            <Box sx={{ maxHeight: '45vh', overflowY: 'auto'}}>
                <Grid container spacing={2}>
                    {/* Profile Section - left on desktop, top on mobile */}
                    <Grid item xs={12} lg={6}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h4" color="primary.darker">Your Profile</Typography>
                            {/* <EditIcon
                                sx={{ 
                                    cursor: 'pointer', 
                                    color: 'primary.main',
                                    fontSize: '1.5rem'
                                }}
                                onClick={editProfile}
                            /> */}
                        </Box>
                        <Box sx={{ mt: 1,  border: '1px solid #eee', borderRadius: 2, minWidth: 320, backgroundColor: 'white' }}>
                            {editMode ? (
                                <>
                                    <TextField
                                        label="Partner Name"
                                        value={partnerName}
                                        onChange={e => setPartnerName(e.target.value)}
                                        fullWidth
                                        sx={{ mb: 2, '& .MuiInputBase-input': { fontSize: 20 } }}
                                        InputLabelProps={{ sx: { fontSize: 18 } }}
                                    />
                                    <TextField
                                        label="PAN Number"
                                        value={panNumber}
                                        onChange={e => setPanNumber(e.target.value)}
                                        fullWidth
                                        sx={{ mb: 2, '& .MuiInputBase-input': { fontSize: 20 } }}
                                        InputLabelProps={{ sx: { fontSize: 18 } }}
                                    />
                                    <Divider sx={{ my: 2 }} />
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                        <Button variant="outlined" color="secondary" onClick={() => setEditMode(false)}>
                                            Cancel
                                        </Button>
                                        <Button variant="contained" color="primary" onClick={handleUpdate}>
                                            Save
                                        </Button>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Grid container direction="row" alignItems="center" sx={{  }}>
                                        <Grid item xs={12}>
                                            <FieldView1 fontSize={18} label="Name" value={mlmUserObj.title} />
                                        </Grid>
                                        {/* <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                                            <EditIcon
                                                sx={{ cursor: 'pointer', color: 'primary.main' }}
                                                onClick={()=>handleUpdateDetails()}
                                            />
                                        </Grid> */}
                                        {/* <Grid item xs={6} sx={{ textAlign: 'left' }}>
                                            <FieldView1 fontSize={18} label="PAN" value={mlmUserObj.pan} />
                                        </Grid>
                                        <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                            <FieldView1 fontSize={18} label="Aadhar" value={mlmUserObj.adhar} />
                                        </Grid> */}
                                        <Grid item xs={12} sx={{ textAlign: 'left' }}>
                                            <FieldView1 fontSize={18} label="Address" value={getAddress()} />
                                        </Grid>
                                    </Grid>
                                    {/* <Divider sx={{ my: 2 }} />
                                    <Grid container direction="row" justifyContent="flex-end">
                                        <Button variant="outlined" color="primary" onClick={() => handleUpdateDetails()}>
                                            Update Profile
                                        </Button>
                                    </Grid> */}
                                </>
                            )}
                        </Box>
                    </Grid>
                    
                </Grid>
            </Box>

            {/* Fixed Go to Membership button at bottom right */}
            <Box
                sx={{
                    padding: 1,
                    mt:1,
                    //position: 'fixed',
                    // bottom: 24,
                    // right: 24,
                    zIndex: 1201, // above drawers
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 1,
                }}
            >
                {/* <Typography variant="caption" color="text.secondary" sx={{ mt: 1, width: '100%', textAlign: 'right', backgroundColor: '' }}>
                    Profile can be updated later, also.
                </Typography> */}
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={handleGoToMembership}
                >
                    Go to Business Associate page
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={() => close()}
                >
                    Product Catalogue
                </Button>
            </Box>
            <ProfileMgmtModal />
            {/* <EdituserActionModal /> */}
           
        </>
    )
}